import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {forkJoin, Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CovidService {
  worldData = null;
  public twett = '../assets/tweet.png';
  public proxy = 'https://proxy-api-168602.appspot.com/';
  public covid = 'https://covidncbi-dot-biogadgets-api.appspot.com/';
  public apiUrl = 'https://wuhan-coronavirus-api.laeyoung.endpoint.ainize.ai/jhu-edu/latest';
  constructor(private http: HttpClient) { }

  getData() {
    return this.http.get(this.apiUrl);
  }

  getPopularArticles() {
    return this.http.get(`https://biogadgets-api.appspot.com/covid19/`);
  }

  formattArticles(item) {
    const { abstract } = item;
    let liteAbstract = '';
    const newTitle = item.title.replace(/^[0-9]{1,2}\)/, '');
    const newDOI = item.doi.replace('"', '');
    liteAbstract = abstract && abstract.length > 350 ?
    liteAbstract = abstract.substring(0, 350) + '...' :
    abstract;
    item.title = newTitle;
    item.doi = newDOI;
    item.liteAbstract = liteAbstract;
    return item;
  }

  getScientist(page) {
    return this.http.get(`${this.proxy}https://tweets-dot-biogadgets-api.appspot.com/tweets/scientists/${page}`);
  }

  getHashtags(hashtag) {
    const item = hashtag.toLowerCase();
    return this.http.get(`${this.proxy}https://tweets-dot-biogadgets-api.appspot.com/tweets/${item}/`);
  }

  getCategories() {
    return this.http.get('https://covidinfo-dot-biogadgets-api.uc.r.appspot.com/data');
  }

  countDuplicated(arr) {
    const len = arr.length;
    const result = {};
    for (let i = 0; i < len; i++) {
      if (arr[i].category === '') {
        // tslint:disable-next-line:no-string-literal
        result['Other'] = (result['Other'] || 0) + 1;
      } else {
      result[arr[i].category] = (result[arr[i].category] || 0) + 1;
      }
    }
    return result;
  }

  cleanData(arr){
    return arr.filter(elem => elem.url && elem.display_name);
  }

  getWeeks() {
    return this.http.get(`${this.covid}stats/week`);
  }

  getMonth() {
    return this.http.get(`${this.covid}stats/month`);
  }

  getCovidCategories() {
    return this.http.get(`${this.covid}categories`);
  }

  getCovidCountries() {
    return this.http.get(`${this.covid}countries`);
  }

  searchAll(page){
    return this.http.get(`${this.covid}references/?page=${page}`);
  }

  searchByAuthor(author, page) {
    return this.http.get(`${this.covid}references/searchauthor/${encodeURIComponent(author)}/?page=${page}`);
  }

  searchByAbstract(abstract, page) {
    return this.http.get(`${this.covid}references/searchabstract/${encodeURIComponent(abstract)}/?page=${page}`);
  }

  searchByTitle(title, page) {
    return this.http.get(`${this.covid}references/searchtitle/${encodeURIComponent(title)}/?page=${page}`);
  }

  searchByCategory(category, page) {
    return this.http.get(`${this.covid}references/bycategory/${encodeURIComponent(category)}/?page=${page}`);
  }

  searchByCountry(country, page) {
    return this.http.get(`${this.covid}references/bycountry/${encodeURIComponent(country)}/?page=${page}`);
  }

  formatCategories(item){
    const regex = /(^[a-z]|\s[a-z])/gm;
    item.uid = item.category;
    item.category = item.category.split('_').join(' ');
    const match = item.category.match(regex);
    let first = null;
    let second = null;

    if (match.length === 2) {
      first = match[0].toUpperCase();
      second = match[1].charAt(1).toUpperCase();
      item.category = item.category.replace(match[0], first);
      item.category = item.category.replace(match[1], ` ${second}`);
    } else {
      first = match[0].toUpperCase();
      item.category = item.category.replace(match[0], first);
    }
    return item;
  }

  getWeekLabels() {
    return this.http.get('../assets/weekLabels.json');
  }

  getMonthLabels() {
    return this.http.get('../assets/monthLabels.json');
  }

  formatDataChart(type, data, labels, output) {
    data.map((item: any) => {
      const result = [labels[item.period - 1][type], item.total];
      output.push(result);
    });
    return output;
  }

  getLiteAbstract(item){
    if (item.abstract && item.abstract.length > 350) {
      item.liteAbstract = `${item.abstract.substring(0, 350)}...`;
    }
    return item;
  }

  formatCountries(item) {
    let newName = null;
    switch (item.country) {
      case 'Russian Federation':
        newName = 'Russia';
        item.country = newName;
        break;
      case 'Korea, Republic of':
        newName = 'South Korea';
        item.country = newName;
        break;
      case 'Iran, Islamic Republic of':
        newName = 'Iran';
        item.country = newName;
        break;
      case 'Syrian Arab Republic':
        newName = 'Syria';
        item.country = newName;
        break;
      case 'Bolivia, Plurinational State of':
        newName = 'Bolivia';
        item.country = newName;
        break;
      case 'Tanzania, United Republic of':
        newName = 'Bolivia';
        item.country = newName;
        break;
      case 'Venezuela, Bolivarian Republic of':
        newName = 'Venezuela';
        item.country = newName;
        break;
      case 'Viet Nam':
        newName = 'Vietnam';
        item.country = newName;
        break;
      case 'Congo':
        newName = 'CD';
        item.country = newName;
        break;
      case 'Timor-Leste':
        newName = 'TL';
        item.country = newName;
        break;
      }
    return Object.values(item);
  }

  setMapData(data) {
    this.worldData = data;
  }

  getMapData() {
    return this.worldData;
  }
}
